import { motion } from "framer-motion";
import { SITE } from "@/lib/site";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-white/[0.06] pt-24 pb-10 overflow-hidden"
    >
      <div className="absolute left-1/2 -bottom-40 -translate-x-1/2 h-[400px] w-[900px] rounded-full bg-[#1d52c4]/20 blur-[140px] pointer-events-none" />
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10 relative">
        {/* Brand row */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
          className="flex flex-col md:flex-row items-start md:items-end justify-between gap-8"
        >
          <div className="flex items-end gap-6">
            <img
              src={`${process.env.PUBLIC_URL || ""}/assets/logo/ge.png`}
              alt="Giriraj Enterprises"
              className="h-24 md:h-40 w-auto ge-halo"
            />
            <div className="pb-2 md:pb-3">
              <div className="font-display text-4xl md:text-6xl tracking-tighter leading-none">
                Giriraj{" "}
                <span className="italic font-light text-white/50">
                  Enterprises.
                </span>
              </div>
              <div className="mt-3 font-mono-tag text-[10px] uppercase text-white/50">
                Switches · Lighting · Fans · Wires & Cables
              </div>
            </div>
          </div>

          <a
            href={`https://wa.me/${SITE.phoneRaw}?text=${SITE.waIntro}`}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => {
              e.preventDefault();
              const url = `https://wa.me/${SITE.phoneRaw}?text=${SITE.waIntro}`;
              const w = window.open(url, "_blank", "noopener,noreferrer");
              if (!w) window.location.href = url;
            }}
            className="inline-flex items-center gap-2 rounded-full bg-[#25d366] text-white px-6 py-3 text-sm font-semibold hover:bg-[#22c55e] transition-colors duration-300 shadow-[0_20px_40px_-10px_rgba(37,211,102,0.55)]"
          >
            Chat with Kunal →
          </a>
        </motion.div>

        <div className="mt-16 grid md:grid-cols-12 gap-10 border-t border-white/[0.06] pt-10">
          <div className="md:col-span-4">
            <div className="font-mono-tag text-[10px] uppercase text-white/40 mb-3">
              Store
            </div>
            <p className="text-white/70 text-sm leading-relaxed max-w-[36ch]">
              {SITE.address}
            </p>
            <a
              href={SITE.mapsLink}
              target="_blank"
              rel="noreferrer"
              className="mt-3 inline-block text-[#22d3ee] text-sm hover:text-white transition-colors duration-300"
            >
              Get directions →
            </a>
          </div>

          <div className="md:col-span-3">
            <div className="font-mono-tag text-[10px] uppercase text-white/40 mb-3">
              Direct
            </div>
            <a
              href={`tel:${SITE.phone.replace(/\s/g, "")}`}
              className="block text-white hover:text-[#22d3ee] transition-colors duration-300"
            >
              {SITE.phone}
            </a>
            <a
              href={`https://wa.me/${SITE.phoneRaw}`}
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => {
                e.preventDefault();
                const url = `https://wa.me/${SITE.phoneRaw}`;
                const w = window.open(url, "_blank", "noopener,noreferrer");
                if (!w) window.location.href = url;
              }}
              className="mt-1 block text-white/70 hover:text-[#25d366] transition-colors duration-300 text-sm"
            >
              WhatsApp · Kunal Mundada
            </a>
          </div>

          <div className="md:col-span-3">
            <div className="font-mono-tag text-[10px] uppercase text-white/40 mb-3">
              Hours
            </div>
            {SITE.hours.map((h) => (
              <div key={h.day} className="text-sm">
                <span className="text-white/50 mr-2">{h.day}</span>
                <span className="text-white/85">{h.time}</span>
              </div>
            ))}
          </div>

          <div className="md:col-span-2">
            <div className="font-mono-tag text-[10px] uppercase text-white/40 mb-3">
              Follow
            </div>
            <ul className="space-y-1.5 text-sm text-white/70">
              <li>
                <a
                  href={`https://wa.me/${SITE.phoneRaw}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={(e) => {
                    e.preventDefault();
                    const url = `https://wa.me/${SITE.phoneRaw}`;
                    const w = window.open(url, "_blank", "noopener,noreferrer");
                    if (!w) window.location.href = url;
                  }}
                  data-testid="social-whatsapp"
                  className="hover:text-[#25d366] transition-colors duration-300 inline-flex items-center gap-1.5"
                >
                  WhatsApp <span aria-hidden>↗</span>
                </a>
              </li>
              <li>
                <a
                  href={SITE.social.instagram}
                  target="_blank"
                  rel="noreferrer"
                  data-testid="social-instagram"
                  className="hover:text-[#22d3ee] transition-colors duration-300 inline-flex items-center gap-1.5"
                >
                  Instagram <span aria-hidden>↗</span>
                </a>
              </li>
              <li>
                <a
                  href={SITE.social.googleReviews}
                  target="_blank"
                  rel="noreferrer"
                  data-testid="social-google-reviews"
                  className="hover:text-[#22d3ee] transition-colors duration-300 inline-flex items-center gap-1.5"
                >
                  Google Reviews <span aria-hidden>↗</span>
                </a>
              </li>
              <li>
                <a
                  href={SITE.mapsLink}
                  target="_blank"
                  rel="noreferrer"
                  data-testid="social-maps"
                  className="hover:text-[#22d3ee] transition-colors duration-300 inline-flex items-center gap-1.5"
                >
                  Google Maps <span aria-hidden>↗</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/[0.06] flex flex-col md:flex-row items-start md:items-center justify-between gap-4 font-mono-tag text-[10px] uppercase text-white/40">
          <span>
            © {new Date().getFullYear()} Giriraj Enterprises · Est.{" "}
            {SITE.established}
          </span>
          <span>Made with precision in Nanded, IN</span>
        </div>
      </div>
    </footer>
  );
}
